const carouselItems = [
  {
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20breaking%20news%20studio%20with%20red%20breaking%20news%20banner%20effect%2C%20dark%20atmosphere%20with%20spotlight%2C%20professional%20broadcast%20setting%2C%20cinematic%20lighting%2C%20warm%20red%20and%20black%20color%20palette%2C%20no%20people%20or%20text&width=900&height=500&seq=carousel-01-2026&orientation=landscape',
    tag: '本周最热',
    title: '网红圈大地震：多位千万级博主卷入数据造假丑闻，行业信任危机全面爆发',
    desc: '从直播带货到短视频，数据造假产业链被连根拔起，涉及平台超过二十家。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Mysterious%20backstage%20corridor%20with%20dramatic%20shadows%20and%20warm%20lighting%2C%20elegant%20theater%20setting%2C%20red%20curtains%20and%20golden%20accents%2C%20cinematic%20photography%20with%20rich%20contrast%2C%20no%20people&width=900&height=500&seq=carousel-02-2026&orientation=landscape',
    tag: '深度专题',
    title: '选秀节目十年沉浮录：从全民狂欢到口碑崩塌，谁是幕后推手？',
    desc: '回顾选秀节目黄金十年，揭秘制作方与选手之间不为人知的利益链条。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Modern%20social%20media%20monitoring%20room%20with%20multiple%20glowing%20screens%2C%20dark%20atmosphere%2C%20cyber%20security%20theme%2C%20red%20and%20blue%20ambient%20lighting%2C%20professional%20photography%2C%20no%20identifiable%20content%20on%20screens&width=900&height=500&seq=carousel-03-2026&orientation=landscape',
    tag: '独家调查',
    title: 'MCN暗战：头部机构互相挖角、商业诋毁，千万博主的去留之战',
    desc: '三家头部MCN被曝商业间谍行为，签约博主沦为资本博弈的棋子。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Luxury%20celebrity%20estate%20exterior%20at%20dusk%20with%20dramatic%20lighting%2C%20gated%20mansion%20with%20palm%20trees%2C%20paparazzi%20style%20photography%2C%20dark%20moody%20atmosphere%2C%20warm%20golden%20hour%20tones%2C%20no%20people&width=900&height=500&seq=carousel-04-2026&orientation=landscape',
    tag: '明星追踪',
    title: '娱乐圈税务风暴再起：多位一线艺人被约谈，补税金额惊人',
    desc: '继前一轮税务整顿后，新一轮调查涉及范围更广，已有多名艺人配合调查。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20film%20set%20with%20professional%20lighting%20equipment%2C%20empty%20director%20chair%2C%20dark%20atmosphere%2C%20movie%20production%20environment%2C%20cinematic%20photography%20with%20deep%20shadows%20and%20warm%20highlights%2C%20no%20people&width=900&height=500&seq=carousel-05-2026&orientation=landscape',
    tag: '幕后揭秘',
    title: '大制作电影资金黑洞：三亿投资去向成谜，剧组工作人员集体讨薪',
    desc: '号称年度最受期待的电影项目陷入资金链断裂危机，拍摄全面暂停。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Elegant%20courtroom%20with%20dramatic%20lighting%2C%20wooden%20furniture%2C%20legal%20atmosphere%2C%20dark%20and%20warm%20color%20palette%2C%20cinematic%20photography%2C%20empty%20room%20with%20sunlight%20streaming%20through%20windows%2C%20no%20people&width=900&height=500&seq=carousel-06-2026&orientation=landscape',
    tag: '法律观察',
    title: '短视频版权大战升级：三大平台互诉侵权，涉案金额突破十亿',
    desc: '围绕热门短视频内容版权归属，平台间的法律纠纷已进入白热化阶段。',
  },
];

export default function Carousel() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            焦点专题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            深度追踪报道，全网最详细的黑料事件全解析
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselItems.map((item, i) => (
            <article
              key={i}
              className="group bg-white rounded-2xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[16/9] overflow-hidden bg-background-100">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 text-xs font-medium bg-accent-500 text-white rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 leading-snug mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}